import React from 'react'
import ProductPriceComponent from '../ProductPriceComponent'
import ProductImageComponent from '../ProductImageComponent'
import { Col, Row } from 'react-bootstrap';
import useMobileScreen from '../useMobileScreen';
import { useTranslation } from '../../hooks/useTranslation';

function ProductSummaryRows({ product, qty, lang }) {
    const { t } = useTranslation()
    const isMobile = useMobileScreen();

    const getProductTranslations = (prod) => {
        if (product && product.translations) {
            let ProductTranslations = product.translations.filter((p) => {
                return p.languageIsoCode == lang && p.propductId == prod.propductId;
            });
            return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
        }
        return {};
    };
    const getProdName = () => {
        return getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName;
    }

    return (
        <Row className="daily-product-summary">
            {
                isMobile ?
                    <div className='row pb-3'>
                        <div className='col-4'>
                            <ProductImageComponent
                                showPrice={false}
                                product={product}
                            />
                        </div>
                        <div className='col-6'>
                            <span>{getProdName()}</span>

                        </div>
                    </div>
                    :
                    <Col sm={6} className="position-relative pb-2">
                        <ProductImageComponent
                            showPrice={false}
                            product={product}
                        />
                    </Col>
            }

            <Col md={12} lg={6} sm={12}>
                {!isMobile &&
                    <div className="pb-3">
                        <span>{getProdName()}</span>
                    </div>
                }
                <div className={'d-flex justify-content-between pb-3 ' + (isMobile ? 'border-bottom mb-3' : '')}>
                    <span>{t("Price")}</span>
                    <ProductPriceComponent product={product} />
                </div>
                <div className={'d-flex justify-content-between pb-3 ' + (isMobile ? 'border-bottom mb-3' : '')}>
                    <span>{t("Quantity")}</span>
                    <span>{qty}</span>
                </div>
                <div className={'d-flex justify-content-between pb-3 ' + (isMobile ? 'border-bottom mb-3' : '')}>
                    <span>{t("Total")}</span>
                    <ProductPriceComponent
                        product={product}
                        multiply={qty}
                    />
                </div>
            </Col>
        </Row>
    )
}
export default ProductSummaryRows;